export default __webpack_public_path__ + "static/media/bluebackround.da9f37d1.svg";